import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { school, formatApiError, payfastCheckout, goToCheckout } from "../../lib/api";
import { ProviderPicker, pickDefaultProvider } from "../ProviderPicker";

export const SubscriptionCard = ({ cls, info, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const [provider, setProvider] = useState(() => pickDefaultProvider(info?.providers));
  const active = cls.status === "active";
  const configured = !!info?.providers?.[provider];
  const home = cls.kind === "homeschool";
  const who = home ? "children" : "students";

  const run = async (fn) => {
    setBusy(true);
    try {
      await fn();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  const subscribe = () => run(async () => {
    goToCheckout(provider === "payfast" ? await payfastCheckout("school", cls.class_id) : await school.checkout(cls.class_id));
  });
  const cancel = () => run(async () => {
    await school.cancel(cls.class_id);
    toast.success("Class subscription cancelled");
    onChanged();
  });

  return (
    <div data-testid="class-subscription-card" className={`what-plan ${active ? "what-plan-pro" : ""}`}>
      <p className="font-mono text-xs uppercase tracking-[0.16em] flex items-center gap-1.5 text-[#D4FF3A]"><Sparkles size={12} /> {home ? "Homeschool plan" : "School subscription"}</p>
      <p data-testid="class-subscription-status" className="font-display text-2xl font-bold text-white mt-2">
        {active ? `Active: all ${who} have Pro` : `R${cls.price} / month`}
      </p>
      <p className="text-sm text-slate-400 mt-1">
        {active ? `Every ${home ? "child" : "student"} can use ChatGPT, Claude and Gemini together.` : `Covers up to ${cls.seats} ${who}${home ? " in your family" : " in this class"}. Without it, ${who} use the free plan (1 AI).`}
      </p>
      {active ? (
        <button data-testid="class-cancel-btn" onClick={cancel} disabled={busy} className="what-btn-ghost w-full mt-4">
          {busy && <Loader2 size={15} className="animate-spin" />} Cancel subscription
        </button>
      ) : (
        <div className="mt-4 space-y-3">
          <ProviderPicker providers={info?.providers} value={provider} onChange={setProvider} />
          <button data-testid="class-subscribe-btn" onClick={subscribe} disabled={busy || !configured} className="what-btn-primary w-full !py-3">
            {busy && <Loader2 size={15} className="animate-spin" />} {home ? "Subscribe my family" : "Subscribe this class"}
          </button>
        </div>
      )}
      {!active && info && !configured && (
        <p data-testid="class-payments-not-configured" className="text-xs text-amber-400 mt-2">{provider === "payfast" ? "PayFast" : "Paystack"} payments aren't set up yet. Please check back soon.</p>
      )}
    </div>
  );
};
